module.exports = __webpack_public_path__ + "static/img/logo_mars.7c4d534.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_mars.svg
// module id = RcQy
// module chunks = 1